import { createModel } from "@rematch/core";
import { CustomerSectorsStatistics, DashboardFilterState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, multiRequest, signoutIfUnauthorized } from "./utilities";

const initialState: CustomerSectorsStatistics = {
  loading: true,
  pending: null,
  count: 0,
  countOnlyElectricity: 0,
  countOnlyGas: 0,
  countOnlyHeating: 0,
  countOnlyGlassFiber: 0,
  countOnlyElectricityAndGas: 0,
  countOnlyElectricityAndHeating: 0,
  countOnlyElectricityAndGlassFiber: 0,
  countOnlyGasAndHeating: 0,
  countOnlyHeatingAndGlassFiber: 0,
  countOnlyElectricityGasAndHeating: 0,
  countOnlyElectricityGasAndGlassFiber: 0,
  countOnlyGasHeatingAndGlassFiber: 0,
};

export const customerSectorsStatistics = createModel<RootModel>()({
  state: initialState as CustomerSectorsStatistics,
  reducers: {
    fetchPending(state, requestId: string) {
      return multiRequest.updatePending(state, requestId);
    },
    fetchSuccess(
      state,
      payload: Partial<CustomerSectorsStatistics>,
      requestId: string
    ) {
      return multiRequest.updateSuccess(payload, state, requestId);
    },
    fetchFail(state, requestId: string) {
      return multiRequest.updateFail(state, requestId);
    },
  },
  effects: (dispatch) => ({
    async fetchCustomerSectorsStatistics(
      dashboardFilter: DashboardFilterState,
      rootState
    ) {
      const requestId = multiRequest.getRequestId();
      dispatch.customerSectorsStatistics.fetchPending(requestId);

      const token = checkToken(rootState, () =>
        dispatch.customerSectorsStatistics.fetchFail(requestId)
      );
      if (!token) return;

      try {
        const customerSectorsStatisticsResult = await api.fetchCustomerSectorsStatistics(
          token,
          dashboardFilter
        );
        dispatch.customerSectorsStatistics.fetchSuccess(
          customerSectorsStatisticsResult.data,
          requestId
        );
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.customerSectorsStatistics.fetchFail(requestId);
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/customerSectorsStatistics.ts